/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { showToast } from 'src/core/helpers'
import { Button, Divider, Form, Col, Row } from 'antd'
import { useTranslation } from 'next-i18next'
import { SendOutlined } from '@ant-design/icons'
import { Country, PushNotification } from 'src/core/models'
import React, { useEffect, useState } from 'react'
import { useAppSelector } from 'src/app/hooks'
import {
  CustomTextArea,
  CustomTextInput,
  CustomText,
  CustomModal,
  CountrySelector,
  LanguageSelector,
  CustomDatePicker
} from 'src/components'
import {
  userAuthenticatedState,
  createPushNotificationsAPI,
  updateNotificationAPI,
  countryListSelector
} from 'src/features'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import moment from 'moment'
interface CreatePushNotificationFormProps {
  notification?: PushNotification,
  isModalVisible: boolean
  setIsModalVisible: (value: boolean) => void
}

const CreatePushNotificationForm: React.FC<CreatePushNotificationFormProps> = (props) => {
  const { isModalVisible, setIsModalVisible, notification = null } = props
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const { first_name, last_name } = useAppSelector(userAuthenticatedState)
  const countryList: Country[] = useAppSelector(countryListSelector)
  const queryClient = useQueryClient()
  const [notificationState, setNotificationState] = useState<PushNotification>(null)

  useEffect(() => {
    if (notification && !(typeof notification?.country === 'number')){
      notification.country = countryList.find((item) => item.code2 === notification.country)?.id || ''
      setNotificationState(notification)
    }
  }, [notificationState, notification])

  const { mutate: createMutate, isLoading: createLoading } = useMutation(createPushNotificationsAPI, {
    onSuccess: () => {
      showToast('success', t('Notification added successfully'), 3)
      handleCancel()
    },
    onError: () => {
      showToast('error', t('Failed to add notification'), 3)
    },
    onSettled: () => {
      // @ts-ignore
      queryClient.invalidateQueries('pushNotification')
    }
  })

  const { mutate: editMutate, isLoading: editLoading } = useMutation(updateNotificationAPI, {
    onSuccess: () => {
      showToast('success', t('Notification edited successfully'), 3)
      handleCancel()
    },
    onError: () => {
      showToast('error', t('Failed to edit notification'), 3)
    },
    onSettled: () => {
      // @ts-ignore
      queryClient.invalidateQueries('pushNotification')
    }
  })

  const handleCancel = () => {
    form.resetFields()
    setIsModalVisible(false)
  }

  const handleSubmit = async (values: PushNotification) => {
    const requestData: PushNotification = {
      owner: `${first_name} ${last_name}`,
      ...values
    }
    requestData.country = countryList.find((item) => item.id === requestData.country)?.code2 || ''
    if(!values.language){
      requestData.language = ''
    }
    if (!notification) {
      createMutate(requestData)
    } else {
      requestData.id = notification.id
      editMutate(requestData)
    }
  }

  // @ts-ignore
  return (
    <CustomModal
      title={!notification ? t('Create Push Notification') : t('Edit Push Notification')}
      footer={null}
      width={800}
      open={isModalVisible}
      onCancel={handleCancel}
      destroyOnClose
    >
      <Form initialValues={notificationState} form={form} onFinish={handleSubmit}>
        <Row gutter={[24, 24]}>
          <Col span={12}>
            {/* Title */}
            <CustomText label={t('Title')} />
            <CustomTextInput
              name='title'
              placeholder={t('Write the title here...')}
              required
            />
            {/* End Title */}

            {/* Body */}
            <CustomText label={t('Body')} />
            <CustomTextArea
              name='body'
              placeholder={t('Write the body here...')}
              required
            />
            {/* End Body */}

            {/* Destination URL */}
            <CustomText label={t('Destination URL')} />
            <CustomTextInput
              name='destinationUrl'
              placeholder={t('Write the URL here...')}
              type='url'
              required
            />
            {/* End Destination URL */}
          </Col>
          <Col span={12}>
            {/* Language */}
            <CustomText label={t('Language')} />
            <LanguageSelector
              name='language'
              placeholder='Select a language'
              required={false}
            />
            {/* End Language */}

            {/* Country */}
            <CustomText label={t('Country')} />
            <CountrySelector
              name='country'
              placeholder={t('Select a country')}
            />
            {/* End Country */}

            {/* Scheduled Time */}
            <CustomText label={t('Time of notification')} />
            <br />
            <CustomDatePicker
              name='scheduledTime'
              placeholder={t('Select a Scheduled Time')}
              isDisabledDate={true}
              format='DD-MM-YYYY HH:mm:ss'
              showTime
              required
            />
            {/* End Scheduled Time */}
          </Col>
        </Row>
        <Divider />
        <Button
          type='primary'
          htmlType='submit'
          loading={createLoading || editLoading}
          icon={<SendOutlined />}
          block
        >
          {createLoading || editLoading ? t('Adding notification') : t('Add notification')}
        </Button>
      </Form>
    </CustomModal>
  )
}

export default CreatePushNotificationForm
